import React from "react";
import styled from 'styled-components';
import draftToHtml from 'draftjs-to-html';
import ReactHtmlParser from 'react-html-parser';

const TextStyle = styled.div`
    width: 100%;
    line-height: 3rem;
    margin: 0px auto;
    /* text-align: justify; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    span{
        font-size: var(--fs-good-page-text) !important;
    }
`;
const Text =(props)=>{
    return(
            <TextStyle>
                <div style={{ backgroundColor:props.background , color:props.color , fontWeight:props.weight, }}>
                    {ReactHtmlParser(draftToHtml(props.data))}
                </div>
             </TextStyle>
    )

}
export default Text;